export default __webpack_public_path__ + "static/media/tv.2e72ffa1.svg";